import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { AvatarDropdown, AvatarName, } from '@/components';
import defaultSettings from '../config/defaultSettings';
import { requestConfig } from './requestConfig';
import '@ant-design/v5-patch-for-react-19';
import { Navigate } from '@umijs/max'
import { GuangGaoZhuJianQuanGuanLiApi } from '@/services'
import { getParams } from "@gatherstar/utils";
import { HeaderBar } from './components/HeaderBar';

const loginPath = '/user/login';

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      // 仅参数携带token才需要重新获取用户信息
      const { token } = getParams()
      if (token) {
        localStorage.setItem('token', token);
        const res = await GuangGaoZhuJianQuanGuanLiApi.getCurrentUserInfoUsingGet()
        if (res) {
          localStorage.setItem('userInfo', JSON.stringify(res))
        }
      }
      return JSON.parse(localStorage.getItem('userInfo') || '{}')
    } catch (error) {
      console.error(error)
      return {}
    }
  };
  // 如果不是登录页面，执行
  const {location} = history;
  if (![loginPath, '/user/register', '/user/register-result'].includes(location.pathname)) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}


// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({initialState, setInitialState}) => {
  return {
    headerRender: () => <HeaderBar/>,
    // actionsRender: () => [<Question key="doc" />],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName/>,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name,
    // },
    // footerRender: () => <Footer />,
    onPageChange: () => {
    },
    bgLayoutImgList: [],
    links: [],
    siderWidth: 200,
    menuHeaderRender: undefined,
    unAccessible: <Navigate to='/' replace={true}/>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
        </>
      );
    },
    ...initialState?.settings,
  };
};

export function onRouteChange({location, routes}: any) {
  const urlParams = new URLSearchParams(location.search);
  // 携带token自动登录
  const managerToken = urlParams.get('token');
  if (managerToken) {
    localStorage.setItem('token', managerToken);
  }
  const token = localStorage.getItem('token');
  // 如果没有登录，重定向到 login
  if (!token && location.pathname !== loginPath) {
    history.replace(loginPath);
  }
}

export const request: RequestConfig = requestConfig
